'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _preact = require('preact');

var _preact2 = require('unistore/preact');

var _constants = require('../../constants');

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Logo = function Logo(props) {
  var product = props.product,
      square = props.square,
      host = props.host,
      children = props.children,
      outherProps = _objectWithoutProperties(props, ['product', 'square', 'host', 'children']);

  if (square) {
    return (0, _preact.h)('img', _extends({ src: '' + host + _constants.PRODUCTS[product].square, 'aria-hidden': true, alt: 'Logo ' + _constants.PRODUCTS[product].name }, outherProps));
  }

  return (0, _preact.h)('img', _extends({ src: '' + host + _constants.PRODUCTS[product].logoWhite, 'aria-hidden': true, alt: 'Logo ' + _constants.PRODUCTS[product].name }, outherProps));
};

exports.default = (0, _preact2.connect)(function (_ref) {
  var heimdall = _ref.heimdall;
  return {
    host: heimdall.host
  };
})(Logo);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/components/Logo/index.js
// module id = 193
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38